export default "__VITE_ASSET__BlmG3_rR__"